import { render } from "./CanonJSPage.vue?vue&type=template&id=16ef559c"
import script from "./CanonJSPage.vue?vue&type=script&lang=js"
export * from "./CanonJSPage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Threejs\\VuejsThreejsForDemo-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__